/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLazyQuery } from '@apollo/client';
import { XMPP_REGISTER_USER, FIREBASE_REGISTER_USER } from '../services/apollo/Queries';
import { set_online_users } from '../redux/messageSlice';
import { getXmppToken, modifyMyMsg, scrollToBottom, getONLYUSERSDATA, logout, showVersionPopup, slugify } from './Common';
import { setupFirebaseMessaging } from 'services/firebase/setupFirebase';
import { handleXmppStanza } from 'services/xmpp/handlers';
import logger from './logger';

const { client, xml } = require('@xmpp/client');

var xmpp = {};
if (typeof window !== 'undefined') {
    window.xmpp_client = xmpp;
    window.db_unix = 0;
}
var mute_all_status = true;
let all_conversations = [];

const audio_tone = new Audio('https://wfss001.freeli.io/common/short_tone.mp3');
if (!window.ring_tone) {
    window.ring_tone = new Audio('https://wfss001.freeli.io/common/simple_corporate_tone.mp3');
    window.ring_tone.loop = true;
}

if (typeof window !== 'undefined') {
    if (!localStorage.getItem('xmpp_resource')) {
        localStorage.setItem('xmpp_resource', String(Date.now()));
    }
    window.xmpp_resource = localStorage.getItem('xmpp_resource');
    localStorage.setItem('reload_time', String(Date.now()));
}

function soundNotification(props, res) {
    if (all_conversations.length === 0) return;
    const user_id = props.user.id;
    if (user_id !== res.sender && !mute_all_status) {
        const conversations = all_conversations.filter(
            (i) => i.conversation_id === res.conversation_id
        );
        if (conversations.length && conversations[0].has_mute.indexOf(user_id) > -1) {
            return;
        }
        if (typeof audio_tone?.play === 'function') {
            audio_tone.play().catch((err) => {
                logger.warn('Audio playback failed:', err);
            });
        }
    }
}

function SocketClient(props) {
    const user = props.user;
    all_conversations = useSelector((state) => state.message.conversations);
    const dispatch = useDispatch();

    const [xmppRegisterUser] = useLazyQuery(XMPP_REGISTER_USER);
    const [firebaseRegisterUser] = useLazyQuery(FIREBASE_REGISTER_USER);

    const xmpp_register = async (user_id, user_fullname) => {
        if (xmpp[user_id]) {
            await xmpp[user_id].stop();
            delete xmpp[user_id];
        }

        const xmpp_res = await xmppRegisterUser({
            variables: { user_id, token: getXmppToken() },
            fetchPolicy: 'network-only',
        });

        const response = xmpp_res?.data?.xmpp_register_user;
        logger.log('xmpp:api', response);

        if (response.status) {
            dispatch(set_online_users(response.online_user_lists));

            xmpp[user_id] = client({
                service: 'wss://' + response.xmpp_domain + ':5443/ws',
                domain: response.xmpp_domain,
                username: response.xmpp_user,
                password: 'a123456',
            });

            const stanzaContext = {
                dispatch,
                props,
                user_id,
                user_fullname,
                modifyMyMsg,
                scrollToBottom,
                getONLYUSERSDATA,
                logout,
                showVersionPopup,
                soundNotification,
                slugify,
            };

            xmpp[user_id].on('stanza', async (stanza) => {
                if (!stanza.is('message') || !stanza.getChild('body')) return;
                const data = JSON.parse(stanza.getChild('body').text());
                logger.log(`xmpp:recv:${data.xmpp_type}`, data);
                await handleXmppStanza(data, stanzaContext);
            });

            xmpp[user_id].on('error', (err) => logger.error(err));

            xmpp[user_id].on('online', async () => {
                await xmpp[user_id].send(xml('presence'));
            });

            xmpp[user_id].on('status', () => {});
            xmpp[user_id].on('offline', () => {});

            xmpp[user_id].start().catch((err) => logger.error(err));
        }
    };

    async function updateServiceWorker(user_id, user_fullname, user_email) {
        if (!('serviceWorker' in navigator)) return;

        const sw_registration = await navigator.serviceWorker.register(
            '/service_worker_freeli.js',
            { scope: '/' }
        );

        // Handle SW update lifecycle
        sw_registration.addEventListener('updatefound', () => {
            if (sw_registration.installing) {
                sw_registration.installing.addEventListener('statechange', () => {
                    if (sw_registration.waiting) {
                        // SW waiting — skip handled by service worker itself
                    }
                });
                navigator.serviceWorker.addEventListener('controllerchange', () => {});
            }
        });

        await setupFirebaseMessaging(sw_registration, {
            firebaseRegisterUser,
            userId: user_id,
        });
    }

    useEffect(() => {
        if (user) {
            const user_id = user.id;
            const user_fullname = `${user.firstname} ${user.lastname}`;
            const user_email = user.email;

            xmpp_register(user_id, user_fullname);
            updateServiceWorker(user_id, user_fullname, user_email);
        }

        if (
            window.location.protocol === 'https:' ||
            window.location.hostname === 'localhost'
        ) {
            if (navigator?.mediaDevices) {
                navigator.mediaDevices
                    .getUserMedia({ audio: true, video: true })
                    .then((stream) => stream.getTracks().forEach((track) => track.stop()))
                    .catch((error) => {
                        if (error.name === 'NotFoundError') {
                            logger.error('No media devices found.');
                        } else if (error.name === 'NotAllowedError') {
                            logger.error('Permission denied to access media devices.');
                        } else {
                            logger.error('Error accessing media devices:', error);
                        }
                    });
            } else {
                logger.error('MediaDevices API not supported.');
            }
        }

        window.addEventListener('beforeunload', async () => {
            if (window.server_ts) {
                localStorage.setItem('app_ts', String(window.server_ts));
            }
            for (const id in xmpp) {
                if (xmpp[id]) await xmpp[id].stop();
            }
        });

        window.addEventListener('online', () => {});

        localStorage.setItem('reload_time', String(Date.now()));

        return async () => {
            for (const id in xmpp) {
                if (xmpp[id]) await xmpp[id].stop();
            }
        };
    }, []);

    useEffect(() => {
        mute_all_status = user?.mute_all;
    }, [user?.mute_all]);

    return '';
}

export default SocketClient;
